/* eslint-disable no-shadow */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import {
  getCodeTableDetails,
  setCodeTableDataRowSelected,
  setDataChangeTried,
  setParentSelectedRow,
  updateCodeTableDetails,
} from '../store/actions';
import CodeDomainTable from './CodeDomainTable';
import CodeValueTable from './CodeValueTable';
import { closeTab } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { resetReduxStore } from '../../../contactType/store/actions';
import { isReadOnly as isRead } from '../../../../SharedModules/utilities/utilities';

const CodeTable = ({ location }) => {
  const dispatch = useDispatch();
  const loginState = useSelector(
    (state) => state?.sharedState?.SharedReducer?.loginStateStoreObj
  );
  let isReadOnly = false;
  if (loginState) {
    isReadOnly = isRead(location.pathname, loginState)?.readOnly || false;
  }
  // local State

  const [disableSaveAndCancel, setDisableSaveAndCancel] = useState(false);
  const [actionModal, setActionModal] = useState({ open: false, type: null });
  const [codeDomainFullScreen, setCodeDomainFullScreen] = useState(false);
  const [codeValueFullScreen, setCodeValueFullScreen] = useState(false);
  const [willCloseTab, setWillCloseTab] = useState(false);
  const [currentRowData, setCurrentRowData] = useState({});
  const history = useHistory();

  // Redux State

  const rebateCodeSerchResult = useSelector(
    (state) => state?.sharedState?.CodeTableReducer?.rebateCodeSerchResult
  );

  const errorMessage = useSelector(
    (state) => state?.sharedState?.CodeTableReducer?.errorMessage
  );

  const successMessages = useSelector(
    (state) => state?.sharedState?.CodeTableReducer?.successMessages
  );

  const loading = useSelector(
    (state) => state?.sharedState?.CodeTableReducer?.loading
  );

  const compareRebateCodeSearchResult = useSelector(
    (state) =>
      state?.sharedState?.CodeTableReducer?.compareRebateCodeSearchResult
  );

  const selectedParentKey = useSelector(
    (state) => state?.sharedState?.CodeTableReducer?.selectedParentKey
  );

  const dataChangeTried = useSelector(
    (state) => state?.sharedState?.CodeTableReducer?.dataChangeTried
  );
  const childCodeValueError = useSelector(
    (state) => state?.sharedState?.CodeTableReducer?.childCodeValueError
  );

  useEffect(() => {
    if (rebateCodeSerchResult?.length > 0) {
      const sortedResults = [...rebateCodeSerchResult].sort((a, b) =>
        a.codeDomainKey > b.codeDomainKey ? 1 : -1
      );
      dispatch(setCodeTableDataRowSelected(sortedResults));
      const existingRowData = sortedResults.find(
        (item) => item.codeDomainKey === currentRowData.codeDomainKey
      );
      if (existingRowData) {
        setCurrentRowData(existingRowData);
        dispatch(setParentSelectedRow(existingRowData));
      } else {
        setCurrentRowData(sortedResults[0]); // Set to the first element if not found
        dispatch(setParentSelectedRow(sortedResults[0]));
      }
    }
  }, [rebateCodeSerchResult, currentRowData]); // Trigger when rebateCodeSerchResult or currentRowData changes

  const openActionModal = (type) => {
    setActionModal({ open: true, type });
  };

  const handleActionModalClose = () => {
    setActionModal({ open: false, type: null });
  };

  const handleSave = () => {
    const saveData = _.differenceWith(
      rebateCodeSerchResult,
      compareRebateCodeSearchResult,
      _.isEqual
    );

    const apidata = saveData.map(({ index, codeValue, ...rest }) => {
      return {
        ...rest,
        codeValue: codeValue.map(({ index, isNewRecord, ...rest }) => {
          return { ...rest };
        }),
      };
    });

    dispatch(
      updateCodeTableDetails(apidata, () => {
        handleActionModalClose();
        dispatch(setDataChangeTried(Math.random()));
      })
    );
  };

  const handleCancel = () => {
    dispatch(
      getCodeTableDetails(() => {
        handleActionModalClose();
        dispatch(setDataChangeTried(Math.random()));
      })
    );
  };

  useEffect(() => {
    if (
      rebateCodeSerchResult.length === 0 ||
      _.isEqual(rebateCodeSerchResult, compareRebateCodeSearchResult)
    ) {
      dispatch(getCodeTableDetails());
    }
    return () => {};
  }, []);

  // handling refresh functionality
  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/codeTable' && !disableSaveAndCancel) {
          item.isFormDirty = true;
          if (errorMessage) {
            item.isFormError = true;
          } else {
            item.isFormError = false;
          }
        } else if (item.navTo === '/codeTable') {
          item.isFormDirty = false;
          if (!errorMessage) {
            item.isFormError = false;
          }
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [disableSaveAndCancel, errorMessage]);

  // close popup on click button
  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/codeTable' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs.map((item) => {
        if (item.navTo === '/codeTable' && item.isFormSave) {
          item.isFormSave = false;
          if (!errorMessage) {
            setWillCloseTab(true);
            handleSave();
          }
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);

  useEffect(() => {
    validateBtnDisable(rebateCodeSerchResult, compareRebateCodeSearchResult);
    if (willCloseTab) {
      closeTab('/codeTable', history, dispatch);
      dispatch(resetReduxStore('/codeTable'));
    }
  }, [dataChangeTried]);

  const validateBtnDisable = () => {
    if (_.isEqual(rebateCodeSerchResult, compareRebateCodeSearchResult)) {
      setDisableSaveAndCancel(true);
    } else {
      setDisableSaveAndCancel(false);
    }
  };

  const onParentKeySelection = (data) => {
    setCurrentRowData(data);
    dispatch(setParentSelectedRow(data));
  };

  return (
    <>
      <div className="tabs-container custom-check">
        {loading && <Spinner load={loading} />}
        <CustomSeparator parent1="System" parent2="Code Tables" />
        {successMessages && (
          <DisplaySuccessMessages successMessages={[successMessages]} />
        )}
        {errorMessage && (
          <DisplayErrorMessages errorMessages={[errorMessage]} />
        )}

        {!codeDomainFullScreen && !codeValueFullScreen && (
          <div className="d-flex justify-content-end align-items-center btn-wrapper mt-3 mb-3">
            <Button
              className="btn btn-success btn-search"
              onClick={() => openActionModal('Save')}
              disabled={
                disableSaveAndCancel || childCodeValueError || isReadOnly
              }
            >
              <SVGComponent iconName="Icon-awesome-save" />
              Save
            </Button>
            <Button
              onClick={() => openActionModal('Cancel')}
              className="btn btn-cancel btn btn-primary"
              disabled={disableSaveAndCancel || isReadOnly}
            >
              <SVGComponent iconName="Icon-cancel" />
              Cancel
            </Button>
          </div>
        )}
        {!codeValueFullScreen && (
          <CodeDomainTable
            rebateCodeSerchResult={rebateCodeSerchResult}
            childCodeValueError={childCodeValueError}
            selectedParentKey={selectedParentKey}
            onParentKeySelection={onParentKeySelection}
            fullScreen={codeDomainFullScreen}
            setFullScreen={setCodeDomainFullScreen}
            isReadOnly={isReadOnly}
          />
        )}

        {!codeDomainFullScreen && (
          <CodeValueTable
            selectedParentKey={currentRowData}
            fullScreen={codeValueFullScreen}
            setFullScreen={setCodeValueFullScreen}
            isReadOnly={isReadOnly}
          />
        )}

        <SaveCancelPopup
          open={actionModal.open}
          title={actionModal.type}
          onConfim={() => {
            if (actionModal.type === 'Save') {
              handleSave();
            } else {
              handleCancel();
            }
          }}
          onCancel={handleActionModalClose}
          moduleName=""
        />
      </div>
    </>
  );
};

export default CodeTable;
